export function resolveLocalizedField(record, field, locale) {
  const translations = record[`${field}_translations`]
  if (translations) {
    if (translations[locale]) return translations[locale]
    if (translations.en) return translations.en
    const anyTranslation = Object.values(translations).find(Boolean)
    if (anyTranslation) return anyTranslation
  }
  return record[field] ?? null
}

export function localizeSalesperson(person, locale) {
  return {
    ...person,
    job_title: resolveLocalizedField(person, 'job_title', locale),
    market_product_focus: resolveLocalizedField(person, 'market_product_focus', locale),
  }
}
